import type { UserBadgeReputation } from 'generated/openapi/types.gen';
import type { ComponentProps } from 'react';
import { memo } from 'react';

import { ProfileNonToxicIcon } from '@/features/profile/components/profileNonToxicIcon';
import { TIER_REQUIREMENTS_MAP } from '@/features/profile/modals/profileNonToxicModal/constants';
import { getTierRequirementText } from '@/features/profile/utils/nonToxic';
import { Badge, type BadgeProps } from '@/shared/components/ui/badge';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/shared/components/ui/tooltip';

export interface ProfileBehaviorBadgeProps extends Omit<
  ComponentProps<'span'>,
  'children'
> {
  reputationBadge: UserBadgeReputation;
  badgeVariant?: BadgeProps['variant'];
}

const transformations = [
  {
    width: 24,
    height: 24,
  },
];

export const ProfileBehaviorBadge = memo(function ProfileBehaviorBadge({
  reputationBadge,
  badgeVariant = 'secondary',
  ...props
}: ProfileBehaviorBadgeProps) {
  const tier = reputationBadge.tier;
  const tooltipText = getTierRequirementText(
    tier,
    reputationBadge.recentFeedback,
  );

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge variant={badgeVariant} {...props}>
          <ProfileNonToxicIcon
            className="size-3"
            transformations={transformations}
            tier={tier}
          />
          <span>{TIER_REQUIREMENTS_MAP[tier].label}</span>
        </Badge>
      </TooltipTrigger>
      <TooltipContent>
        <p>{tooltipText}</p>
      </TooltipContent>
    </Tooltip>
  );
});
